import React, { useEffect, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { PageItem } from 'components';
import './pagination.scss';
export function PaginationList({ page, changePage }) {

  const [pageNumber, setPageNumber] = useState([]);

  const transformPages = (totalPages) => {
    let counter = 1;
    let pages = [];
    while (totalPages >= counter) {
      pages.push(counter)
      counter++;
    }
    return pages;
  }

  useEffect(() => {
    if(page.totalPage){
      page.totalPage.then((value) => {
        const numberPage = [value];
        setPageNumber(transformPages(numberPage));
      });
    }
  },[page.totalPage]);

  const getNumberPage = (item) => {
    changePage(item);
  }

  const firstPage = (event)=> {
    event.preventDefault();
    changePage(0);
  }

  const lastPage = (event)=> {
    event.preventDefault();
    page.totalPage.then((totalPages)=> {
      changePage(totalPages);
    })
  }

  const renderItem = (itens) => {
    return itens.map((item, index) => {
      return (
        <PageItem key={index} numberPage={item} getNumberPage={getNumberPage} />
      )
    })

  }

  return (
    <div className="pagination-grid">
      <Pagination aria-label="Page navigation example">
        <PaginationItem onClick={firstPage}>
          <PaginationLink first/>
        </PaginationItem>
        {renderItem(pageNumber)}
        <PaginationItem onClick={lastPage}>
          <PaginationLink last/>
        </PaginationItem>
      </Pagination>
    </div>
  )
}
